// extracted by mini-css-extract-plugin
export var heroImage = "_dm-1";
export var modal = "_dm-0";